module.exports = __webpack_public_path__ + "static/images/comment_bg.e463b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/comment_bg.png
// module id = srq1
// module chunks = 11